import React from "react";

const ActivationSuccess = () => {
  return (
    <div
      style={{
        textAlign: "center",
        position: "fixed",
        top: "40%",
        left: "auto",
        right: "auto",
        width: "100%",
      }}
    >
      <h2>
        Uspješno ste aktivirali nalog. Ubrzo će Vam stići mejl za reset lozinke.
      </h2>

      <a href="/login">
        <button
          style={{ color: "white", background: "black", padding: "3px 8px" }}
        >
          Vrati se na login
        </button>
      </a>
    </div>
  );
};

export default ActivationSuccess;
